/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Button, Col, List, Modal, Row, Typography } from 'antd';
import { CheckBenefitIcon, CheckThinIcon, DerhamIcon } from '~/img';
import styled, { css } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useIsMobile } from '~/hooks/useScreenSizes';
import { useDirection } from '~/hooks/i18nHooks';

function ServiceDetailsModal(props: any) {
  const {
    inputType,
    title,
    visible,
    onCancel,
    footer,
    width,
    disable,
    checked,
    feesAndCharges,
    imgUrl,
    serviceBenefits,
    type,
    handleSelect,
    inputName,
    totalFee,
  } = props;
  const { t } = useTranslation('ksaApplication');
  const dir = useDirection();
  const isMobile = useIsMobile();
  console.log('inputType', inputType);
  return (
    <StyledModal
      title={title}
      visible={visible}
      onCancel={onCancel}
      footer={footer}
      width={width}
      centered={true}
      closable={false}
    >
      <ModalContainer dir={dir} isMobile={isMobile}>
        <div className="serviceContentWrapper">
          {isMobile ? (
            <>
              <img
                src={imgUrl}
                alt="service-image"
                className="mobileServiceImage"
              />
              <Typography.Paragraph className="subTitleText">
                {t(`${inputType}SubTitle`)}
              </Typography.Paragraph>
              <Typography.Paragraph className="LongDescriptionText">
                {t(`${inputType}LongDescription`)}
              </Typography.Paragraph>
              <List
                className="benefitListWrapper"
                size="small"
                bordered={false}
                dataSource={serviceBenefits}
                renderItem={(item) => (
                  <List.Item className="benefitListItem">
                    <Row className="benefitItem">
                      <CheckBenefitIcon className="benefitIcon" />
                      <Typography.Paragraph className="benefitText">
                        {t(`${item}`)}
                      </Typography.Paragraph>
                    </Row>
                  </List.Item>
                )}
              />
              {inputType === 'e-commerce' && (
                <BnplInfoNote dir={dir}>
                  <BnplInfoIcon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                      <path d="M9.99984 10.8334V5.83341M10.4165 13.7501C10.4165 13.9802 10.23 14.1667 9.99984 14.1667C9.76972 14.1667 9.58317 13.9802 9.58317 13.7501M10.4165 13.7501C10.4165 13.52 10.23 13.3334 9.99984 13.3334C9.76972 13.3334 9.58317 13.52 9.58317 13.7501M10.4165 13.7501H9.58317M18.3332 10.0001C18.3332 14.6025 14.6022 18.3334 9.99984 18.3334C5.39746 18.3334 1.6665 14.6025 1.6665 10.0001C1.6665 5.39771 5.39746 1.66675 9.99984 1.66675C14.6022 1.66675 18.3332 5.39771 18.3332 10.0001Z" stroke="#0069B1" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </BnplInfoIcon>
                  <span>{t('Tabby and Tamara require separate onboarding with the respective provider.')}</span>
                </BnplInfoNote>
              )}
            </>
          ) : (
            <div className="desktopLayout">
              <div className="imageWrapper">
                <LeftImageContainer>
                  <img
                    src={imgUrl}
                    alt="service-image"
                    className="desktopServiceImage"
                  />
                </LeftImageContainer>
              </div>
              <div className="desktopModalContent">
                <Typography.Paragraph className="subTitleText">
                  {t(`${inputType}SubTitle`)}
                </Typography.Paragraph>
                <Typography.Paragraph className="LongDescriptionText">
                  {t(`${inputType}LongDescription`)}
                </Typography.Paragraph>

                <div className="benefitList">
                  {serviceBenefits?.map((item: string, index: number) => (
                    <div key={index} className="benefitItem">
                      <CheckBenefitIcon className="benefitIcon" />
                      <Typography.Paragraph className="benefitText">
                        {t(`${item}`)}
                      </Typography.Paragraph>
                    </div>
                  ))}
                </div>
                {inputType == 'e-commerce' && (
                  <BnplInfoNote dir={dir}>
                    <BnplInfoIcon>
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20" fill="none">
                        <path d="M9.99984 10.8334V5.83341M10.4165 13.7501C10.4165 13.9802 10.23 14.1667 9.99984 14.1667C9.76972 14.1667 9.58317 13.9802 9.58317 13.7501M10.4165 13.7501C10.4165 13.52 10.23 13.3334 9.99984 13.3334C9.76972 13.3334 9.58317 13.52 9.58317 13.7501M10.4165 13.7501H9.58317M18.3332 10.0001C18.3332 14.6025 14.6022 18.3334 9.99984 18.3334C5.39746 18.3334 1.6665 14.6025 1.6665 10.0001C1.6665 5.39771 5.39746 1.66675 9.99984 1.66675C14.6022 1.66675 18.3332 5.39771 18.3332 10.0001Z" stroke="#0069B1" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </BnplInfoIcon>
                    <span>{t('Tabby and Tamara require separate onboarding with the respective provider.')}</span>
                  </BnplInfoNote>
                )}
              </div>
            </div>
          )}
          <div className="feesWrapper">{feesAndCharges}</div>
        </div>
        <SelectButton
          disabled={disable}
          checked={checked}
          type="primary"
          onClick={() => handleSelect()}
        >
          {checked ? t('Remove') : t('Select')}
        </SelectButton>
      </ModalContainer>
    </StyledModal>
  );
}

const StyledModal = styled(Modal)`
  z-index: 999999999;
  .ant-modal-content {
    border-radius: 20px !important;
    overflow: hidden;
  }
  .ant-modal-header {
    padding-bottom: 0px !important;
    border-radius: 20px 20px 0 0 !important;
  }
`;

const LeftImageContainer = styled.div`
  background: #f0f7ff;
  border-radius: 16px;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  overflow: hidden;
`;

const SelectButton = styled(Button) <{ checked?: boolean }>`
  width: 100%;
  margin-top: 20px;
  font-weight: 600;
  background: ${({ checked }) => (checked ? '#E12E56' : '#0069B1')} !important;
  border-color: ${({ checked }) => (checked ? '#E12E56' : '#0069B1')} !important;
`;

// Shared base typography for body text (14px, Inter/Tajawal, 24px line-height)
const bodyBaseCSS = css<{ dir?: string }>`
  font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
  font-size: 14px;
  font-style: normal;
  line-height: 24px;
  letter-spacing: 0.14px;
  margin-bottom: 0;
`;

const ModalContainer = styled.div<any>`
  text-align: ${({ dir }) => (dir === 'rtl' ? 'right' : 'left')};

  /* ── Wrapper ── */
  .serviceContentWrapper {
    width: 100%;
    border-radius: 16px;
  }

  /* ── Mobile image ── */
  .mobileServiceImage {
    width: 100%;
    object-fit: cover;
    height: 160px;
    border-radius: 16px;
  }

  /* ── Mobile benefit list ── */
  .benefitListWrapper {
    width: 100%;
    margin-top: 16px;
    margin-bottom: 0;
  }

  /* ── Desktop layout ── */
  .desktopLayout {
    display: flex;
    gap: 24px;
    width: 100%;
    align-items: stretch;
  }

  .imageWrapper {
    flex: 1 1 50%;
    min-width: 0;
    display: flex;
    align-self: stretch;
  }

  .desktopServiceImage {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  /* ── Fees section ── */
  .feesWrapper {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  /* ── Typography ── */
  .subTitleText {
    ${bodyBaseCSS}
    color: #070707;
    font-weight: 700;
    ${({ isMobile }) => isMobile && 'margin-bottom: 10px; margin-top: 4px;'}
  }
  .vatText {
    color: #000;
    text-align: right;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.22px;
    margin-top: -8px;
  }
  .desktopModalContent {
    min-height: 350px;
    box-sizing: border-box;
    display: flex;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    flex: 1 1 50%;
    min-width: 0;
    align-self: stretch;
    border-radius: 12px;
    border: 1px solid #c2dbec;
    overflow-y: auto;
  }
  .benefitList {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    flex: 1;
  }
  .LongDescriptionText {
    ${bodyBaseCSS}
    color: #4a4a4a;
    font-weight: 500;
  }
  .benefitListItem {
    width: 100%;
    margin-left: -18px;
  }
  .benefitItem {
    display: flex;
    align-items: flex-start;
    width: 100%;
    margin-bottom: 4px;
  }
  .benefitIcon {
    flex-shrink: 0;
    margin-right: 10px;
    margin-left: 10px;
  }
  .benefitText {
    ${bodyBaseCSS}
    margin: 0;
    flex: 1;
    min-width: 0;
    color: #070707;
    font-weight: 400;
  }
  .totalFee {
    color: #000;
    text-align: right;
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 40px;
  }
  .ant-list {
    border: none !important;
    .ant-list-items {
      border-top: none;
      border-bottom: none;
      .ant-list-item {
        border: none !important;
      }
    }
  }
`;

export default ServiceDetailsModal;

// ─── BNPL Info Note ───────────────────────────────────────────────────────────
const BnplInfoNote = styled.div<{ dir?: string }>`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 10px;
  background: #EBF4FB;
  direction: ${({ dir }) => dir ?? 'ltr'};

  span {
    font-family: ${({ dir }) => (dir === 'rtl' ? 'Tajawal' : 'Inter')}, sans-serif;
    font-size: 13px;
    font-weight: 400;
    color: #1C2027;
    line-height: 20px;
  }
`;

const BnplInfoIcon = styled.span`
  flex-shrink: 0;
  margin-top: 2px;
  display: flex;
  align-items: center;
`;
